class User {
    constructor(user) {
        const safeUser = user || {}
        Object.assign(this, safeUser)
        this.membership = Array.isArray(safeUser.membership)
            ? safeUser.membership
            : []
        this.currentTeam = this.membership[0]?.teamId || null
    }

    isSuperUser() {
        if (!this.membership) return false
        return this.membership.some(
            (membership) =>
                membership.teamName === 'Dexter' && membership.role === 'Admin'
        )
    }

    isTeamAdmin() {
        if (!this.membership) return false
        const currentMembership = this.membership.filter(
            (membership) => membership.teamId === this.currentTeam
        )[0]
        if (!currentMembership) return false
        return currentMembership.role === 'Admin'
    }

    isTeamMember() {
        if (!this.membership) return false
        return (
            this.isSuperUser() ||
            this.membership.some(
                (membership) => membership.teamId === this.currentTeam
            )
        )
    }

    isDecibio() {
        if (!this.membership) return false
        return this.membership.some((obj) => obj.teamName === 'Decibio')
    }

    setCurrentTeam(teamId) {
        this.currentTeam = teamId
    }
}

export default User
